import { __awaiter, __decorate, __extends, __generator } from "tslib";
import format from 'date-fns/format';
import jaLocale from 'date-fns/locale/ja';
import { Component, Vue, Prop } from 'vue-property-decorator';
import liff from '@line/liff';
import { SurveyApi, EntryApi, TargetUserApi } from '../apis';
var surveyApi = new SurveyApi(undefined);
var entryApi = new EntryApi(undefined);
var targetUserApi = new TargetUserApi(undefined);
var StartPage = /** @class */ (function (_super) {
    __extends(StartPage, _super);
    function StartPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.appType = '';
        _this.lineID = '';
        _this.targetUser = null;
        _this.line = {
            name: '---',
            pictureUrl: '',
            id: ''
        };
        _this.survey = null;
        return _this;
    }
    StartPage.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.appType = this.$store.state.appType;
                        _a = this;
                        return [4 /*yield*/, surveyApi.getSurvey(this.surveyId).then(function (res) { return res.data; })];
                    case 1:
                        _a.survey = _b.sent();
                        this.$store.commit('setSurvey', { survey: this.survey });
                        if (this.survey && this.survey.title) {
                            document.title = this.survey.title;
                        }
                        if (!(this.appType == 'LINE')) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.initializeLiff()];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    StartPage.prototype.start = function () {
        return __awaiter(this, void 0, void 0, function () {
            var entry;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.survey) {
                            alert("survey not define");
                            return [2 /*return*/];
                        }
                        entry = {
                            surveyID: this.survey.id,
                            tenantID: this.survey.tenantID,
                            targetUserID: this.targetUser ? this.targetUser.id : 0,
                            entryAt: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSSxxxxx", { locale: jaLocale })
                        };
                        return [4 /*yield*/, entryApi.createEntry(entry).then(function (res) { return res.data; })];
                    case 1:
                        entry = _a.sent();
                        this.$store.commit('setEntry', { entry: entry });
                        this.$store.commit('setNextQuestionID', { nextQuestionID: this.$store.state.survey.startQuestionID });
                        this.$emit('start');
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(StartPage.prototype, "classes", {
        get: function () {
            return {
                'diag-start-button': true
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StartPage.prototype, "styles", {
        get: function () {
            if (this.survey && this.survey.mainColor) {
                // alert(`mainColor: ${this.survey.mainColor}`)
            }
            else {
                // alert(`mainColor is empty`)
            }
            return {
                '--color': (this.survey && this.survey.mainColor) ? this.survey.mainColor : 'green'
            };
        },
        enumerable: false,
        configurable: true
    });
    StartPage.prototype.initializeLiff = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                // alert(`initializeLiff ${this.liffId}`)
                liff.init({
                    liffId: this.liffId
                })
                    .then(function () {
                    // start to use LIFF's api
                    _this.setLineID();
                })
                    .catch(function (err) {
                    // this.message.context = `liff init error ${err} liffId=${this.liffId}`
                });
                return [2 /*return*/];
            });
        });
    };
    StartPage.prototype.setLineID = function () {
        var _this = this;
        // alert(`start setLineID ${liff.isInClient()}`)
        if (!liff.isInClient()) {
            return;
        }
        liff.getProfile().then(function (profile) { return __awaiter(_this, void 0, void 0, function () {
            var request, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        // alert(`LINE profile ${profile.userId} ${profile.displayName}`)
                        this.line.id = profile.userId;
                        this.line.name = profile.displayName;
                        this.line.pictureUrl = profile.pictureUrl;
                        request = {
                            tenantID: this.survey && this.survey.tenantID ? this.survey.tenantID : 0,
                            lineID: profile.userId,
                            name: this.line.name
                        };
                        // alert(`createTargetUser call ${JSON.stringify(request)}`)
                        _a = this;
                        return [4 /*yield*/, targetUserApi.createTargetUser(request).then(function (res) { return res.data; })
                            // alert(`createTargetUser called ${JSON.stringify(this.targetUser)}`)
                        ];
                    case 1:
                        // alert(`createTargetUser call ${JSON.stringify(request)}`)
                        _a.targetUser = _b.sent();
                        return [2 /*return*/];
                }
            });
        }); }).catch(function (err) {
            alert("Error at getProfile: " + err);
        });
    };
    __decorate([
        Prop({ type: Number, required: true })
    ], StartPage.prototype, "surveyId", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], StartPage.prototype, "liffId", void 0);
    StartPage = __decorate([
        Component({})
    ], StartPage);
    return StartPage;
}(Vue));
export default StartPage;
